export const liveStub = {
    "typeMatches": [
    {
        "matchType": "International",
        "seriesMatches": [
            {
                "seriesAdWrapper": {
                    "seriesId": 7476,
                    "seriesName": "ICC Mens T20 World Cup 2024",
                    "matches": [
                        {
                            "matchInfo": {
                                "matchId": 87738,
                                "seriesId": 7476,
                                "seriesName": "ICC Mens T20 World Cup 2024",
                                "matchDesc": "35th Match, Group B",
                                "matchFormat": "T20",
                                "startDate": "1718497800000",
                                "endDate": "1718510400000",
                                "state": "In Progress",
                                "status": "Australia opt to bowl",
                                "team1": {
                                    "teamId": 23,
                                    "teamName": "Scotland",
                                    "teamSName": "SCO",
                                    "imageId": 172137
                                },
                                "team2": {
                                    "teamId": 4,
                                    "teamName": "Australia",
                                    "teamSName": "AUS",
                                    "imageId": 172117
                                },
                                "venueInfo": {
                                    "id": 59,
                                    "ground": "Daren Sammy National Cricket Stadium",
                                    "city": "Gros Islet, St Lucia",
                                    "timezone": "-04:00",
                                    "latitude": "14.070532",
                                    "longitude": "-60.931743"
                                },
                                "currBatTeamId": 23,
                                "seriesStartDt": "1717200000000",
                                "seriesEndDt": "1719792000000",
                                "isTimeAnnounced": true,
                                "stateTitle": "In Progress",
                                "isFantasyEnabled": true
                            },
                            "matchScore": {
                                "team1Score": {
                                    "inngs1": {
                                        "inningsId": 1,
                                        "runs": 49,
                                        "wickets": 1,
                                        "overs": 5.4
                                    }
                                }
                            }
                        },
                        {
                            "matchInfo": {
                                "matchId": 87731,
                                "seriesId": 7476,
                                "seriesName": "ICC Mens T20 World Cup 2024",
                                "matchDesc": "34th Match, Group B",
                                "matchFormat": "T20",
                                "startDate": "1718470800000",
                                "endDate": "1718483400000",
                                "state": "Complete",
                                "status": "England won by 41 runs (DLS method)",
                                "team1": {
                                    "teamId": 9,
                                    "teamName": "England",
                                    "teamSName": "ENG",
                                    "imageId": 172123
                                },
                                "team2": {
                                    "teamId": 161,
                                    "teamName": "Namibia",
                                    "teamSName": "NAM",
                                    "imageId": 172229
                                },
                                "venueInfo": {
                                    "id": 109,
                                    "ground": "Sir Vivian Richards Stadium",
                                    "city": "North Sound, Antigua",
                                    "timezone": "-04:00",
                                    "latitude": "17.103332",
                                    "longitude": "-61.784959"
                                },
                                "currBatTeamId": 9,
                                "seriesStartDt": "1717200000000",
                                "seriesEndDt": "1719792000000",
                                "isTimeAnnounced": true,
                                "stateTitle": "ENG Won",
                                "isFantasyEnabled": true
                            },
                            "matchScore": {
                                "team1Score": {
                                    "inngs1": {
                                        "inningsId": 1,
                                        "runs": 122,
                                        "wickets": 5,
                                        "overs": 9.6
                                    }
                                },
                                "team2Score": {
                                    "inngs1": {
                                        "inningsId": 2,
                                        "runs": 84,
                                        "wickets": 3,
                                        "overs": 9.6
                                    }
                                }
                            }
                        }
                    ]
                }
            },
            {
                "adDetail": {
                    "name": "native_matches",
                    "layout": "native_large",
                    "position": 1
                }
            },
            {
                "seriesAdWrapper": {
                    "seriesId": 8256,
                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                    "matches": [
                        {
                            "matchInfo": {
                                "matchId": 96433,
                                "seriesId": 8256,
                                "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                "matchDesc": "20th Match, Group B",
                                "matchFormat": "T20",
                                "startDate": "1718457300000",
                                "endDate": "1718469900000",
                                "state": "Complete",
                                "status": "Romania won by 24 runs",
                                "team1": {
                                    "teamId": 1041,
                                    "teamName": "Romania",
                                    "teamSName": "ROM",
                                    "imageId": 247204
                                },
                                "team2": {
                                    "teamId": 554,
                                    "teamName": "Israel",
                                    "teamSName": "ISR",
                                    "imageId": 172606
                                },
                                "venueInfo": {
                                    "id": 1942,
                                    "ground": "Simar Cricket Ground",
                                    "city": "Rome",
                                    "timezone": "+02:00",
                                    "latitude": "17.31922",
                                    "longitude": "78.31205"
                                },
                                "currBatTeamId": 1041,
                                "seriesStartDt": "1717891200000",
                                "seriesEndDt": "1718668800000",
                                "isTimeAnnounced": true,
                                "stateTitle": "ROM Won"
                            },
                            "matchScore": {
                                "team1Score": {
                                    "inngs1": {
                                        "inningsId": 1,
                                        "runs": 149,
                                        "wickets": 7,
                                        "overs": 19.6
                                    }
                                },
                                "team2Score": {
                                    "inngs1": {
                                        "inningsId": 2,
                                        "runs": 125,
                                        "wickets": 7,
                                        "overs": 19.6
                                    }
                                }
                            }
                        },
                        {
                            "matchInfo": {
                                "matchId": 96424,
                                "seriesId": 8256,
                                "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                "matchDesc": "19th Match, Group A",
                                "matchFormat": "T20",
                                "startDate": "1718457300000",
                                "endDate": "1718469900000",
                                "state": "Complete",
                                "status": "France won by 40 runs",
                                "team1": {
                                    "teamId": 539,
                                    "teamName": "France",
                                    "teamSName": "FRA",
                                    "imageId": 172590
                                },
                                "team2": {
                                    "teamId": 897,
                                    "teamName": "Turkey",
                                    "teamSName": "TKY",
                                    "imageId": 247208
                                },
                                "venueInfo": {
                                    "id": 1475,
                                    "ground": "Roma Cricket Ground",
                                    "city": "Rome",
                                    "timezone": "+02:00",
                                    "latitude": "17.31922",
                                    "longitude": "78.31205"
                                },
                                "currBatTeamId": 539,
                                "seriesStartDt": "1717891200000",
                                "seriesEndDt": "1718668800000",
                                "isTimeAnnounced": true,
                                "stateTitle": "FRA Won"
                            },
                            "matchScore": {
                                "team1Score": {
                                    "inngs1": {
                                        "inningsId": 1,
                                        "runs": 167,
                                        "wickets": 6,
                                        "overs": 19.6
                                    }
                                },
                                "team2Score": {
                                    "inngs1": {
                                        "inningsId": 2,
                                        "runs": 127,
                                        "wickets": 10,
                                        "overs": 19.3
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        ]
    },
    {
        "matchType": "League",
        "seriesMatches": [
            {
                "seriesAdWrapper": {
                    "seriesId": 7336,
                    "seriesName": "T20 Blast 2024",
                    "matches": [
                        {
                            "matchInfo": {
                                "matchId": 84672,
                                "seriesId": 7336,
                                "seriesName": "T20 Blast 2024",
                                "matchDesc": "South Group",
                                "matchFormat": "T20",
                                "startDate": "1718474400000",
                                "endDate": "1718487000000",
                                "state": "Complete",
                                "status": "Surrey won by 54 runs",
                                "team1": {
                                    "teamId": 148,
                                    "teamName": "Surrey",
                                    "teamSName": "SUR",
                                    "imageId": 172215
                                },
                                "team2": {
                                    "teamId": 41,
                                    "teamName": "Sussex",
                                    "teamSName": "SUS",
                                    "imageId": 172148
                                },
                                "venueInfo": {
                                    "id": 292,
                                    "ground": "County Ground",
                                    "city": "Hove",
                                    "timezone": "+01:00",
                                    "latitude": "50.830995",
                                    "longitude": "-0.163522"
                                },
                                "currBatTeamId": 148,
                                "seriesStartDt": "1717027200000",
                                "seriesEndDt": "1726444800000",
                                "isTimeAnnounced": true,
                                "stateTitle": "SUR Won"
                            },
                            "matchScore": {
                                "team1Score": {
                                    "inngs1": {
                                        "inningsId": 1,
                                        "runs": 184,
                                        "wickets": 8,
                                        "overs": 19.6
                                    }
                                },
                                "team2Score": {
                                    "inngs1": {
                                        "inningsId": 2,
                                        "runs": 130,
                                        "wickets": 10,
                                        "overs": 18.1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        ]
    }
],
    "filters": {
    "matchType": [
        "International",
        "League",
        "Domestic",
        "Women"
    ]
},
    "appIndex": {
    "seoTitle": "Live Cricket Score - Scorecard and Match Results",
        "webURL": "www.cricbuzz.com/live-cricket-scores/"
},
    "responseLastUpdated": "1718499391"
}
